module.exports = __webpack_public_path__ + "static/media/landingImage3.22bf5a88.png";